import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Select from 'components/generics/Select';

const ExploitationTableRow = ({ data, handleData, deleteData, checked, setChecked }) => {
  const { t } = useTranslation();
  const [selectedSecteur, setSelectedSecteur] = useState('');
  const [selectedExploitation, setSelectedExploitation] = useState('');
  const [selectedGroundType, setSelectedGroundType] = useState('');

  const isChecked =
    checked?.find(
      (checkedExploitation) =>
        checkedExploitation?.exploitationId === data?.exploitation?.wiuzExploitationId,
    )?.checked || false;
  useEffect(() => {
    if (data.exploitation.sectorId) {
      setSelectedSecteur(data.exploitation.sectorId);
    }
    if (data.exploitation.exploitationTypeName) {
      let found = data.type.filter(
        (d) => d.exploitationTypeName === data.exploitation.exploitationTypeName,
      );
      if (found.length > 0) {
        setSelectedExploitation(found[0].id);
      } else {
        setSelectedExploitation(data.type.filter((d) => d.isDefaultType === true)[0]?.id);
      }
    } else {
      setSelectedExploitation(data.type.filter((d) => d.isDefaultType === true)[0]?.id);
    }
  }, [data]);

  const handleChange = (e, from) => {
    const exploitationId = +data.exploitation.wiuzExploitationId;
    const dataToHandle = {
      exploitationId,
      sectorId: +selectedSecteur,
      exploitationTypeId: +selectedExploitation,
      groundTypeId: +selectedGroundType,
    };
    const fields = {
      secteur: { key: 'sectorId', set: setSelectedSecteur },
      exploitation: { key: 'exploitationTypeId', set: setSelectedExploitation },
      groundType: { key: 'groundTypeId', set: setSelectedGroundType },
    };

    if (from === 'checkbox') {
      setChecked((prev) =>
        prev.map((item) => ({
          ...item,
          checked: item?.exploitationId === exploitationId ? !isChecked : false,
        })),
      );
      if (isChecked) deleteData(exploitationId);
      else handleData(dataToHandle);
      return;
    }

    const field = fields[from];
    if (!field) return;
    field.set(e);
    handleData({ ...dataToHandle, [field.key]: +e });
  };

  return (
    <tr>
      <td className="import">
        <input
          type={'checkbox'}
          checked={isChecked}
          onChange={(e) => handleChange(e, 'checkbox')}
        />
      </td>
      <td>{data.exploitation.wiuzExploitationName}</td>
      <td>
        <Select
          className="reduce"
          name="groundType"
          options={[{ id: 0, name: t('column.soilTypes') }, ...data?.groundTypes]}
          value={selectedGroundType}
          itemLabel="name"
          itemValue="id"
          disabled={!isChecked || !!data.exploitation.sectorId}
          onChange={(e) => handleChange(e, 'groundType')}
        />
      </td>
      <td>
        <Select
          className="reduce"
          name="secteur"
          options={[{ id: 0, name: t('label.assoliaSectors') }, ...data.secteur]}
          value={selectedSecteur}
          itemLabel="name"
          itemValue="id"
          disabled={!isChecked || !!data.exploitation.sectorId}
          onChange={(e) => handleChange(e, 'secteur')}
        />
      </td>
      <td>
        <Select
          className="reduce"
          name="exploitation"
          options={[{ id: 0, exploitationTypeName: t('label.exploitationTypes') }, ...data.type]}
          value={selectedExploitation}
          itemLabel="exploitationTypeName"
          itemValue="id"
          disabled={!isChecked || !!data.exploitation.exploitationTypeName}
          onChange={(e) => handleChange(e, 'exploitation')}
        />
      </td>
    </tr>
  );
};

export default ExploitationTableRow;
